import React from 'react';
import { BD } from '../bookDemoTheme';

interface StepHeadingProps {
  title: string;
  subtitle?: string;
}

const StepHeading: React.FC<StepHeadingProps> = ({ title, subtitle }) => (
  <div className="text-center mb-8 sm:mb-10">
    <h1
      className={`text-[26px] sm:text-[42px] font-bold tracking-[-0.01rem] leading-9 sm:leading-[59px] mb-3 ${BD.textPrimary}`}
    >
      {title}
    </h1>
    {subtitle && (
      <p className={`text-[14px] sm:text-[16px] leading-5 sm:leading-6 font-normal ${BD.textSecondary}`}>{subtitle}</p>
    )}
  </div>
);

export default StepHeading;
